import { FC } from "react"
import { SchedulesBatchImport } from "../../../module/schedules/containers/batchImport"

export const SchedulesBatchImportPage: FC = () => <SchedulesBatchImport />
